<template>
  <!-- 玫瑰图 -->
  <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
</template>
  
  <script>
// refId                 图表id
// datas                 图表数据源
// isLegend              图表名称值   
// colorList             颜色值
// titleText             标题
// nameColor             文字颜色

export default {
  props: ['refId', 'datas', 'legendList', 'titleText', 'colorList', 'nameColor'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue) {
        this.setPieOption(this.refId, newValue, this.colorList, this.legendList, this.titleText, this.nameColor);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas && this.datas.length > 0) {
      this.$nextTick(() => {
        this.setPieOption(this.refId, this.datas, this.colorList, this.legendList, this.titleText, this.nameColor);
      })
    }
  },
  methods: {
    setPieOption(refId, datas, colorList, legendList, titleText, nameColor) {
      if (!datas || datas.length == 0) {
        datas = [{ name: '', value: 0 }]
      }
      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // type: 'scroll',
          // orient: 'vertical',
          // right: 10,
          // top: 20,
          // bottom: 20,
          bottom: 22,
          textStyle: {
            fontSize: 10,//字体大小
            color: nameColor ? nameColor : '#ffffff'//字体颜色
          },
          data: legendList
        },
        textStyle: {
          textShadowColor: 'transparent'
        },
        series: [
          {
            name: titleText,
            type: 'pie',
            // minAngle: 15,              //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
            // avoidLabelOverlap: true,   //是否启用防止标签重叠策略
            radius: [40, 110],
            center: ['50%', '40%'],
            roseType: 'radius',
            label: {
              show: true
            },
            itemStyle: {
              normal: {
                label: {
                  show: true
                },
                color: function (params) {
                  var myColor = ['#1114e2', '#1ae58a', '#b809c1', '#c48f0b',
                    '#389eb6', '#d77fbe', '#d5835a', '#96a0d0',
                    '#88c497', '#9de7d0'];
                  var num = myColor.length;
                  return colorList ? colorList[params.dataIndex % num] : myColor[params.dataIndex % num]
                },
                // barBorderRadius: [2, 0, 0, 2], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
            // emphasis: {
            //   label: {
            //     show: false
            //   }
            // },
            data: datas
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 0,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 1)'
            //   }
            // }
          }
        ],
      }
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      this.pieEcharts.resize();
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },


  },
};
  </script>
  
  <style scoped>
</style>
  